import { graphQueryBang, gql } from "shared/lib/graphql"

const NormalizedAppletUpdate = gql`
  mutation($appletId: String!, $pushEnabled: Boolean, $name: String) {
    normalizedAppletUpdate(
      input: { applet_id: $appletId, push_enabled: $pushEnabled, name: $name }
    ) {
      errors {
        attribute
        message
      }
    }
  }
`

export const updateApplet = async ({ appletId, pushEnabled, name }) => {
  const { normalizedAppletUpdate } = await graphQueryBang(
    NormalizedAppletUpdate,
    {
      appletId,
      pushEnabled,
      name,
    }
  )

  return normalizedAppletUpdate
}
